<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="col-sm-12 ml-auto">
      <div class="card p-4 rounded-plus bg-faded">
        <h1 class="text-center fw-400 mb-4 d-xs-block">{{ $t('titles.set-password') }}</h1>

        <password-form :buttonText="$t('buttons.set')" @setPassword="setPassword" />
      </div>
    </div>
  </div>
</template>

<script>
import { authResource } from '@/resources/auth.resource';
import PasswordForm from '@/components/forms/PasswordForm';

// @vuese
// Ustawianie nowego hasła
// @group Start
export default {
  name: 'SetPassword',
  components: {
    PasswordForm
  },
  methods: {
    // @vuese
    // Ustawia nowe hasło
    setPassword({ password }) {
      authResource
        .setPassword(this.$route.params.token, password)
        .then(() =>
          this.$store.dispatch('showConfirm', {
            title: 'Ustawiono nowe hasło',
            showCloseButton: false,
            submitButton: 'Ok',
            onSuccess: () => this.$router.push({ name: 'login' })
          })
        )
        .catch(() => this.$store.dispatch('notifyError', { title: 'messages.auth.setPasswordError' }));
    }
  }
};
</script>
